

import { Component, Mixins, Prop, PropSync, Watch } from "vue-property-decorator";
import GlobalMixin from "@/mixins/global";
import { IPaymentCard } from "@/components/IBPayment/interface";
import ListSorterByDateField from "@/mixins/sort/list-sorter-by-date-field";
import IBPaymentCardTitle from "@/components/IBPayment/IBPaymentCardTitle.vue";
import IBPaymentCard from "./IBPaymentCard.vue";
import IBPaymentDetailActionSheet from "@/components/IBPayment/IBPaymentDetailActionSheet.vue";
import IBSpinner from "@/components/IBPayment/IBSpinner.vue";
import { PaymentCardVariant } from '@/components/IBPayment/interface';

@Component({
	components: {
		IBPaymentCard,
		IBSpinner,
		IBPaymentCardTitle,
		IBPaymentDetailActionSheet
	}
})
export default class IBPaymentList extends Mixins(
	GlobalMixin,
	ListSorterByDateField
) {
	@Prop({ type: Boolean, default: true })
	readonly pageKeySwift!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly isLoading!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly hideTitle!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly simpleColor!: boolean;

	@Prop(Boolean)
	readonly dense!: boolean;

	@Prop(String)
	readonly variant?: PaymentCardVariant;

	@PropSync('actionSheetOpened', { type: Boolean, default: false })
	actionSheetOpenedLocal!: boolean;

	@Prop(Array)
	readonly list!: IPaymentCard[];

	dateKeyInListItem: string = 'dateTime';

	detailActionSheetOpened: boolean = false;

	selectedPaymentCard: IPaymentCard | null = null;

	selectPaymentCard(v: IPaymentCard): void {
		this.selectedPaymentCard = v;

		if (this.isSm) this.detailActionSheetOpened = this.actionSheetOpenedLocal = !this.detailActionSheetOpened;
	}

	userId(id: number): void {
		this.$emit('userId', id);
	}

	getPayrollUserState(state: any): void {
		this.$emit('getPayrollUserState', state);
	}

  openRegisterInfo(registerId: number): void {
    this.$emit('openRegisterInfo', registerId);
  }

	@Watch('actionSheetOpenedLocal')
	actionSheetOpenedLocalChanged(): void {
		 this.detailActionSheetOpened = this.actionSheetOpenedLocal;
	}
}

